/*
 * Brand spotlight (sections/brand-spotlight.liquid).
 *
 * Two jobs: switch panels from the logo rail (tabs, keyboard accessible), and
 * fill each panel's category breakdown from Algolia. The breakdown is progressive
 * enhancement — the panel is complete without it, so a failed request just leaves
 * the block hidden rather than showing an error.
 */
(function () {
  var cfg = window.AlgoliaConfig;

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Link into the brand's own collection page, whose Algolia shell already reads
  // the `category` param. collectionUrl comes from Liquid so it carries the locale.
  function categoryUrl(collectionUrl, category) {
    return collectionUrl + '?category=' + encodeURIComponent(category);
  }

  function loadBreakdown(panel) {
    if (!cfg || !cfg.appId || panel.dataset.bsLoaded) return;
    panel.dataset.bsLoaded = '1';

    var handle = panel.getAttribute('data-collection-handle');
    var collectionUrl = panel.getAttribute('data-collection-url');
    var wrap = panel.querySelector('[data-bs-breakdown]');
    var list = panel.querySelector('[data-bs-list]');
    if (!handle || !collectionUrl || !wrap || !list) return;

    fetch(
      'https://' + cfg.appId + '-dsn.algolia.net/1/indexes/' +
        encodeURIComponent(cfg.index) + '/query',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Algolia-Application-Id': cfg.appId,
          'X-Algolia-API-Key': cfg.apiKey
        },
        body: JSON.stringify({
          query: '',
          hitsPerPage: 0,
          facets: ['product_type'],
          maxValuesPerFacet: 5,
          facetFilters: [['collections:' + handle]]
        })
      }
    )
      .then(function (r) {
        if (!r.ok) throw new Error('algolia ' + r.status);
        return r.json();
      })
      .then(function (res) {
        // Live count beats the Liquid one: collection counts cap at 25,000 and the
        // display_count metafield is a manual snapshot. Force en-US grouping so the
        // digits match the rest of the site rather than switching to Arabic-Indic.
        var countEl = panel.querySelector('[data-bs-count]');
        if (countEl && typeof res.nbHits === 'number') {
          countEl.textContent = res.nbHits.toLocaleString('en-US');
        }

        var facets = (res.facets && res.facets.product_type) || {};
        var rows = Object.keys(facets)
          .map(function (k) { return { name: k, count: facets[k] }; })
          .sort(function (a, b) { return b.count - a.count; })
          .slice(0, 4);
        if (!rows.length) return;

        list.innerHTML = rows.map(function (r) {
          return '<li><a href="' + esc(categoryUrl(collectionUrl, r.name)) + '">' +
            '<span>' + esc(r.name) + '</span>' +
            '<em>' + r.count.toLocaleString() + '</em></a></li>';
        }).join('');
        wrap.hidden = false;
      })
      .catch(function () { /* panel is complete without it */ });
  }

  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on) loadBreakdown(panel);
        }
      });
      if (focus) tabs[index].focus();
      tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        // Arrow semantics follow reading order, so they invert under RTL.
        var rtl = document.documentElement.getAttribute('dir') === 'rtl';
        if (event.key === 'ArrowRight') next = rtl ? i - 1 : i + 1;
        else if (event.key === 'ArrowLeft') next = rtl ? i + 1 : i - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        select((next + tabs.length) % tabs.length, true);
      });
    });

    // First panel is already visible from Liquid — load its data.
    var first = document.getElementById(tabs[0].getAttribute('aria-controls'));
    if (first) loadBreakdown(first);
  }

  if (!window.customElements.get('brand-spotlight')) {
    window.customElements.define('brand-spotlight', class extends HTMLElement {
      connectedCallback() { init(this); }
    });
  }
})();
